/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Split_Multiview_SuccessInputs */



/**
* | output |
* | --- |
* | "Multiview group has been split into {count} event groups." |
*
* @param {Split_Multiview_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_success = /** @type {((inputs: Split_Multiview_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le groupe Multiview a été divisé en groupes d'événements ${i?.count}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Multiview-Gruppe wurde in ${i?.count}-Ereignisgruppen aufgeteilt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il gruppo Multiview è stato suddiviso in gruppi di eventi ${i?.count}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Группа Multiview разделена на группы событий ${i?.count}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El grupo Multiview se ha dividido en grupos de eventos ${i?.count}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`多视图组已拆分为${i?.count}事件组。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`マルチビューグループは${i?.count}イベントグループに分割されました。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मल्टीव्यू समूह को ${i?.count} इवेंट समूहों में विभाजित किया गया है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O grupo Multiview foi dividido em grupos de eventos ${i?.count}.`)
	return /** @type {LocalizedString} */ (`Multiview group has been split into ${i?.count} event groups.`)
});